import { render, staticRenderFns } from "./part-2-global.vue?vue&type=template&id=ab8784cc&"
import script from "./part-2-global.vue?vue&type=script&lang=js&"
export * from "./part-2-global.vue?vue&type=script&lang=js&"
import style0 from "./part-2-global.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports